jQuery(document).ready(function($){
  $('.side-nav li').each(function(){
    if($(this).hasClass('link-active')){
    	$(this).parent('ul').show();
      $(this).parent('ul').addClass('active');
      $(this).parents('.side-nav .haschild').addClass('active');
      $(this).parents('.side-nav .haschild ul').show();
      $(this).parents('.side-nav .haschild-1 ul').show();
      $(this).parents('.side-nav .haschild-2 ul').show();
      $(this).parents('.side-nav .haschild-3 ul').show();
      
      
     
      
      $(this).parents('.side-nav .haschild').find('.mean-collapse').removeClass('_active');
      $(this).parents('.side-nav .haschild').find('.mean-expand').addClass('_active');
      $(this).parents('.side-nav .haschild-1').find(' .mean-expand-1').addClass('_active');
      $(this).parents('.side-nav .haschild-1').find(' .mean-collapse-1').removeClass('_active');
      $(this).parents('.side-nav .haschild-2').find(' .mean-expand-2').addClass('_active');
      $(this).parents('.side-nav .haschild-2').find('.mean-collapse-2').removeClass('_active');
      $(this).parent('.side-nav .haschild-3').find('.mean-expand-3').addClass('_active');
      $(this).parent('.side-nav .haschild-3').find('.mean-collapse-2').removeClass('_active');
      $(this).parent('.side-nav .haschild-4').find('.mean-expand-4').addClass('_active');
      $(this).parent('.side-nav .haschild-4').find('.mean-collapse-4').removeClass('_active');
      
      
       $(this).parents('.side-nav').find(' .site-nav--active .mean-collapse').removeClass('_active');
       $(this).parents('.side-nav').find(' .site-nav--active .mean-expand,.site-sub-nav--active .mean-expand').addClass('_active');   
      
       $(this).parents('.side-nav').find(' .site-sub-nav--active .mean-collapse-1').removeClass('_active');
       $(this).parents('.side-nav').find(' .site-sub-nav--active .mean-expand-1').addClass('_active'); 
      
       $(this).parents('.side-nav').find(' .site-nav--active ul.site-nav__childlist-grid').show();
       $(this).parents('.side-nav').find(' .site-sub-nav--active ul.site-nav__childlist-grid-1').show();
      
       
      $(this).parent('.side-nav .haschild-4').find('.mean-expand-4').addClass('_active');
      
    }
  });
    
  $('.link-active').parents('.haschild,.haschild-1').addClass('active_dropdown');
 
  
    $('.mean-expand').click(function(){
      $('.haschild').removeClass('active');
      $('.haschild').find('.mean-expand').removeClass('_active');
      $('.haschild').find('.mean-collapse').addClass('_active');
      $('.haschild').find('.site-nav__childlist-grid').hide();
      $(this).parent('.haschild').addClass('active');
      $(this).parent('.haschild').find('.mean-collapse').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild').find('.site-nav__childlist-grid').slideDown();
    });
    
    $('.mean-collapse').click(function(){
      $('.haschild').removeClass('active');
      $('.haschild').find('.mean-expand').removeClass('_active');
      $('.haschild').find('.mean-collapse').addClass('_active');
      $(this).parent('.haschild').removeClass('active');
      $(this).parent('.haschild').find('.mean-expand').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild').find('.site-nav__childlist-grid').slideUp();
    });
    
    $('.mean-expand-1').click(function(){
      $('.haschild-1').removeClass('active');
      $('.haschild-1').find('.mean-expand-1').removeClass('_active');
      $('.haschild-1').find('.mean-collapse-1').addClass('_active');
      $('.haschild-1').find('.site-nav__childlist-grid-1').slideUp();
      $(this).parent('.haschild-1').addClass('active');
      $(this).parent('.haschild-1').find('.mean-collapse-1').removeClass('_active');
      $(this).addClass('_active');
      $(this).siblings('.site-nav__childlist-grid-1').slideDown();
    });
    
    $('.mean-collapse-1').click(function(){
      $('.haschild-1').removeClass('active');
      $('.haschild-1').find('.mean-expand-1').removeClass('_active');
      $('.haschild-1').find('.mean-collapse-1').addClass('_active');
      $(this).parent('.haschild-1').removeClass('active');
      $(this).parent('.haschild-1').find('.mean-expand-1').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild-1').find('.site-nav__childlist-grid-1').slideUp();
    });
    
    $('.mean-expand-2').click(function(){
      $('.haschild-2').removeClass('active');
      $('.haschild-2').find('.mean-expand-2').removeClass('_active');
      $('.haschild-2').find('.mean-collapse-2').addClass('_active');
      $('.haschild-2').find('.site-nav__childlist-grid-2').slideUp();
      $(this).parent('.haschild-2').addClass('active');
      $(this).parent('.haschild-2').find('.mean-collapse-2').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild-2').find('.site-nav__childlist-grid-2').slideDown();
    });
    
    $('.mean-collapse-2').click(function(){
      $('.haschild-2').removeClass('active');
      $('.haschild-2').find('.mean-expand-2').removeClass('_active');
      $('.haschild-2').find('.mean-collapse-2').addClass('_active');
      $(this).parent('.haschild-2').removeClass('active');
      $(this).parent('.haschild-2').find('.mean-expand-2').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild-2').find('.site-nav__childlist-grid-2').slideUp();
    });
    
     $('.mean-expand-3').click(function(){
      $('.haschild-3').removeClass('active');
      $('.haschild-3').find('.mean-expand-3').removeClass('_active');
      $('.haschild-3').find('.mean-collapse-3').addClass('_active');
       $('.haschild-3').find('.site-nav__childlist-grid-3').slideUp();
      $(this).parent('.haschild-3').addClass('active');
      $(this).parent('.haschild-3').find('.mean-collapse-3').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild-3').find('.site-nav__childlist-grid-3').slideDown();
    });
    
    $('.mean-collapse-3').click(function(){
      $('.haschild-3').removeClass('active');
      $('.haschild-3').find('.mean-expand-3').removeClass('_active');
      $('.haschild-3').find('.mean-collapse-3').addClass('_active');
      $(this).parent('.haschild-3').removeClass('active');
      $(this).parent('.haschild-3').find('.mean-expand-3').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild-3').find('.site-nav__childlist-grid-3').slideUp();
    });
    
    $('.mean-expand-4').click(function(){
      $('.haschild-4').removeClass('active');
      $('.haschild-4').find('.mean-expand-4').removeClass('_active');
      $('.haschild-4').find('.mean-collapse-4').addClass('_active');
      $('.haschild-4').find('.site-nav__childlist-grid-4').slideUp();
      $(this).parent('.haschild-4').addClass('active');
      $(this).parent('.haschild-4').find('.mean-collapse-4').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild-4').find('.site-nav__childlist-grid-4').slideDown();
    });
    
    $('.mean-collapse-4').click(function(){
      $('.haschild-4').removeClass('active');
      $('.haschild-4').find('.mean-expand-4').removeClass('_active');
      $('.haschild-4').find('.mean-collapse-4').addClass('_active');
      $(this).parent('.haschild-4').removeClass('active');
      $(this).parent('.haschild-4').find('.mean-expand-4').removeClass('_active');
      $(this).addClass('_active');
      $(this).parent('.haschild-4').find('.site-nav__childlist-grid-4').slideUp();
    });
  });